var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialLinkedin24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.326 6.666A1.67 1.67 0 0 0 6.662 5 1.67 1.67 0 0 0 5 6.666 1.67 1.67 0 0 0 6.662 8.33a1.67 1.67 0 0 0 1.664-1.665zM8.159 19H5.25V9.667h2.91V19zm4.609-9.25H9.94v9.249h2.91v-4.584c0-1.25.25-2.416 1.745-2.416 1.496 0 1.496 1.417 1.496 2.5V19H19v-5.083c0-2.5-.582-4.417-3.49-4.417-1.413 0-2.327.75-2.742 1.5V9.75z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTguMzI2IDYuNjY2QTEuNjcgMS42NyAwIDAgMCA2LjY2MiA1IDEuNjcgMS42NyAwIDAgMCA1IDYuNjY2IDEuNjcgMS42NyAwIDAgMCA2LjY2MiA4LjMzYTEuNjcgMS42NyAwIDAgMCAxLjY2NC0xLjY2NXpNOC4xNTkgMTlINS4yNVY5LjY2N2gyLjkxVjE5em00LjYwOS05LjI1SDkuOTR2OS4yNDloMi45MXYtNC41ODRjMC0xLjI1LjI1LTIuNDE2IDEuNzQ1LTIuNDE2IDEuNDk2IDAgMS40OTYgMS40MTcgMS40OTYgMi41VjE5SDE5di01LjA4M2MwLTIuNS0uNTgyLTQuNDE3LTMuNDktNC40MTctMS40MTMgMC0yLjMyNy43NS0yLjc0MiAxLjVWOS43NXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgSocialLinkedin24 as ReactComponent };